const EmrFeatures = [
    {
        question: "AEMR for All is",
        answer: "Not for profits that provides free, customizable academic EMR (AEMR) templates to support healthcare professionals, and educators worldwide.",
    },
    {
        question: "Let's Start: User Instructions",
        answer: "Click here for user instructions.",
        link: "https://www.notion.so/AEMR4All-User-Instructions-2e0064ea8b4a8084b914fe1ccd516c4d"
    },
    {
        title: "Free and Accessible",
        description: "With a Google account, create and customize AEMR templates at no cost—a budget-friendly solution for your simulations and training sessions.",
        image: "/emr_screen.png",
        alt: "emr_screen"
    },
    {
        title: "Easy Export",
        description: "Simply enter the patient information needed for your case scenario. Your personalized AEMR template is automatically generated and exported to your Google Sheets, ready for unlimited duplication and use.",
        image: "/click_demo.gif",
        alt: "clicking demo"
    },
    {
        title: "Fully Editable",
        description: "The Google Sheets-based charts are editable, enabling you to adapt them seamlessly to fit specific educational and training needs.",
        image: "/update_cell.gif",
        alt: "Update cell"
    },
    {
        question: "Designed for Global Impact",
        answer: "As a non-profit initiative, AEMR for All is dedicated to supporting healthcare educators in financially constrained institutions and underdeveloped countries, enhancing simulation-based education worldwide.",
    },
    {
        question: "Why we started this project?",
        answer: "Simulation-based education (SBE) has advanced with high-fidelity virtual and augmented reality models. " +
            "A recent survey showed 96% of U.S. hospitals use EMR, emphasizing the need for healthcare education to follow suit. " +
            "However, many healthcare professional schools still rely on paper chart notes in SBE due to cost and accessibility issues, " +
            "despite the availability of academic EMR (AEMR) programs.",
    },
    {
        question: "Why Googlesheet?",
        answer: "AEMR4All uses Google Sheets, a free web-based spreadsheet program, as an accessible alternative to paper chart notes in education. " +
            "Google Sheets can house patient data and support interaction, providing students with a simulated environment " +
            "similar to the EMR systems used in real-world practice.",
    },
    {
        question: "Contact",
        answer: "For questions or collaboration inquiries please contact us at the following email address.\n aemr4all@gmail.com",
    },
    {
        question: "Team Members",
        answer: [
            {
                role: "Project Manager",
                name: "Minseung Chu, FNP, DNP-BC",
                title: "Clinical Assistant Professor",
                institution: "University of Illinois Chicago, College of Nursing"
            },
            {
                role: "Program Developer",
                name: "Younghyun Jung, B.A. Computer Science",
                title: "Master of Engineering Student",
                institution: "Cornell University"
            }
        ]
    }
];

export default EmrFeatures;